<template>
  <div class="d-flex align-items-center">
    <members-list
      :members-list="membersList"
      :org-id="orgId"
      :team-id="teamId"
      :sub-org-id="subOrgId"
      :limit="10"
      :avatar-size="22"
    />
    <div :class="{ hidden: membersList.length === 0 }">
      <b-button
        @click="onAddClick"
        class="text-secondary text-decoration-none text-medium py-0"
        variant="link"
        >+ Add
      </b-button>
    </div>
  </div>
</template>
<script>
import MembersList from '@/components/MembersList.vue'
import * as R from 'ramda'
import { BButton } from 'bootstrap-vue/src/index'
import { mapActions } from 'vuex'

export default {
  name: 'TeamMembersList',
  props: ['orgId', 'teamId', 'subOrgId'],
  components: {
    BButton,
    MembersList
  },
  computed: {
    org() {
      return this.$store.getters.orgById(this.orgId) || {}
    },
    team() {
      return this.$store.getters.teamById(this.teamId)
    },
    isRootTeam() {
      return !this.team.parentId
    },
    memberships() {
      return this.team.memberships ? this.team.memberships : []
    },
    /**
     * This function rearranges members with owners in the beginning of the array
     * @returns {*[]}
     */
    membersList() {
      const sortByFullName = R.sortBy(
        R.compose(
          R.toLower,
          R.path(['user', 'displayName'])
        )
      )
      const [owners, regularUsers] = R.partition(R.propEq('type', 'owner'), this.memberships)
      return [...sortByFullName(owners), ...sortByFullName(regularUsers)]
    }
  },
  methods: {
    ...mapActions(['getTeam', 'getOrgMemberships', 'getTeamMemberships']),
    async fetchMemberships() {
      await this.getTeam({ orgId: this.org.id, teamId: this.teamId })
      if (!this.team.memberships) {
        await this.getTeamMemberships({ orgId: this.org.id, teamId: this.teamId })
      }
    },
    onAddClick() {
      if (this.isRootTeam) {
        this.$emit('manageOrgMembers')
      } else {
        this.$emit('manageTeamMembers')
      }
    }
  },
  mounted() {
    if (!this.team.memberships) {
      this.fetchMemberships()
    }
  },
  watch: {
    teamId() {
      if (!this.team.memberships) {
        this.fetchMemberships()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
